import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {environment} from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SkipperService {
  constructor(private http:HttpClient) { }
  verify(id)
  {
        
    const server =  environment.BACK_DOWNLOADER+id;
    return this.http.get(server)
   //ged-backend-cloud-master/novedades
  }

  getUploadedFiles(filters)
  {
    let params='?'
   
    if(filters['id_usuario'])
    {
      params=params+'id_usuario='+filters['id_usuario'];
    }
    params = params + '&estado=' + filters['estado'];
    if(filters['descripcion']!=undefined)
    {
      params=params+'&descripcion='+filters['descripcion']
    }
    if(filters['first']!=undefined)
    {
      params=params+'&skip='+filters['first']
    }
    if(filters['rows']!=undefined)
    {
      params=params+'&limit='+filters['rows']
    }
    if(filters['fecha_guardado_desde']!=undefined)
    {
      params=params+'&fecha_guardado_desde='+filters['fecha_guardado_desde']
    }
    if(filters['fecha_guardado_hasta']!=undefined)
    {
      params=params+'&fecha_guardado_hasta='+filters['fecha_guardado_hasta']
    }
    if(filters['visibilidad']!=undefined)
    {
      params=params+'&condicion='+filters['visibilidad']
    }
    if(filters['id_juzgado']!=undefined)
    {
      params=params+'&id_juzgado='+filters['id_juzgado']
    }
    if(filters['tipo_acto']!=undefined)
    {
      params=params+'&tipo_acto='+filters['tipo_acto']
    }
    if(filters['numero_expediente']!=undefined)
    {
      params=params+'&numero_expediente='+filters['numero_expediente']
    }
    if(filters['condicion']!=undefined)
    {
      params=params+'&condicion='+filters['condicion']
    }
    if(filters['rows']!=undefined)
    {
      params=params+'&limit='+filters['rows']
    }
    if(filters['nombre_archivo']!=undefined)
    {
      params=params+'&nombre_archivo='+filters['nombre_archivo']
    }
    if(filters['fecha_vencimiento_desde']!=undefined)
    {
      params=params+'&fecha_vencimiento_desde='+filters['fecha_vencimiento_desde']
    }
    if(filters['fecha_vencimiento_hasta']!=undefined)
    {
      params=params+'&fecha_vencimiento_hasta='+filters['fecha_vencimiento_hasta']
    }
    if(filters['relevancia']!=undefined)
    {
      params=params+'&relevancia='+filters['relevancia']
    }
    
    const server =  environment.BACK_BANDEJA;

    return this.http.get(server+params)
  }

  getJuzgados()
  {
    const server =  environment.BACK_JUZGADOS;

    return this.http.get(server)
  }

  getTiposActos()
  {
    const server =  environment.BACK_TIPO_ACTO;

    return this.http.get(server)
  }

  getUsuarios()
  {
    const server =  environment.BACK_USUARIOS_DE_OFICINA;
    return this.http.get(server)
  }

  deleteDocumentVideo(par_id_documento, par_motivo) {

    const server =  environment.BACK_BORRA_DOCUMENTO_VIDEO;
    let parametros = '?id_documento=' + par_id_documento + '&motivo=' + par_motivo;
    return this.http.delete(server + parametros)
  }

  closeSession()
  {
    console.log("cerrar sesion")
    let logout_url=environment.KC_URL + 'realms/' + environment.KC_REALM + '/protocol/openid-connect/logout?redirect_uri=' + environment.KEYCLOAK_AUTH_ADDRESS_ENC
   // console.log(logout_url);
    localStorage.clear();
    
   // alert()
    window.location.replace(logout_url);
  }

  checkBackendReach()
  {
    return  this.http.get(environment.BACK_TIPO_ACTO, {responseType: 'text'})
  }
}


